import { useCallback, useState } from "react";
import { Box, Button, IconButton, Typography, Alert } from "@mui/material";
import { sectionSchema } from "../../schema/sectionSchema";
import { mockSectionFields } from "../../data/mockSectionData";
import { useNavigate } from "react-router-dom";
import { createSection } from "../../api/section";
import AuthForm from "../shared/AuthForm";
import ModalContainer from "./ModalContainer";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const initialValues = {
  section_name: "",
};

const CreateSectionModal = ({ openModal, setOpenModal, colors }) => {
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);

    setOpenModal(false);
  };

  const handleFormSubmit = useCallback(async (values) => {
    try {
      await createSection(values);
      setOpenModal(false);
    } catch (error) {
      setAlertMessage(error.message);
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 3000);
    }
  }, [setOpenModal]);

  return (
    <ModalContainer
      openModal={openModal}
      setOpenModal={setOpenModal}
      colors={colors}
    >
      <Box textAlign="start" onClick={handleGoBack}>
        <IconButton sx={{ marginRight: "5px" }}>
          <ArrowBackIcon />
        </IconButton>
        Back to home
      </Box>
      <Typography variant="h1" my={3} color="text.primary">
        Create Section
      </Typography>
      {/* Alert */}
      {showAlert && (
        <Box my={2}>
          <Alert variant="filled" severity="error">
            {alertMessage}
          </Alert>
        </Box>
      )}
      <AuthForm
        initialValues={initialValues}
        validationSchema={sectionSchema}
        fields={mockSectionFields}
        onSubmit={handleFormSubmit}
      >
        <Box display="flex" justifyContent="end" mt="20px">
          <Button type="submit" color="secondary" variant="contained">
            Submit
          </Button>
        </Box>
      </AuthForm>
    </ModalContainer>
  );
};

export default CreateSectionModal;
